<template>
  <div class="template">
    <div class="content-top">
      <el-button type="primary" @click="addNew()" size="mini">新建模板</el-button>
      <div class="template-search">
        <el-input placeholder="输入模板名称" v-model="requestData.template_name" clearable size="small">
          <template slot="append">
            <el-button class="template-search-button" type="primary" @click="clickSearch()" size="small">搜索</el-button>
          </template>
        </el-input>
      </div>
    </div>

    <div class="tabs">
      <el-tabs v-model="activeName" @tab-click="tabChange">
        <el-tab-pane label="全部" name="0"></el-tab-pane>
        <el-tab-pane
          :label="item.category_name + `(${item.pre_count}+${item.count-item.pre_count || 0})`"
          :name="item.id"
          v-for="item in categories" :key="item.id">
        </el-tab-pane>
      </el-tabs>
      <template>

        <el-button type="text" v-if="isHasPermission" @click="dialogClassVisible = true">
          <i class="el-icon-circle-plus el-icon--left"></i>
          新增分类
        </el-button>
        <el-button type="text" v-if="isHasPermission" @click="$router.push('/template-category')">
          <i class="el-icon-edit el-icon--left"></i>
          编辑分类
        </el-button>

      </template>
    </div>

    <InfiniteScroll class="template-item"
      :infinite-scroll="getTemplateList"
      :infinite-scroll-immediate="false"
      :infinite-scroll-disabled="loadDisabled" >

      <cateList
        v-if="template_list.length"
        :data="template_list"
        :infinite-scroll="getTemplateList"
        :infinite-scroll-disabled="loadDisabled"
      ></cateList>

    </InfiniteScroll>


    <!-- 添加分类 -->

    <el-dialog title="添加分类"
      :visible.sync="dialogClassVisible"
      width="40%" >

      <el-form ref="form" label-width="140px">
        <el-form-item label="一级分类" prop="template_name">
          <el-input clearable v-model="category_name" :maxlength="20" placeholder="请输入模板名称"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClassVisible = false; category_name = ''">取 消</el-button>
        <el-button type="primary" @click="addCategory">确 定</el-button>
      </div>

    </el-dialog>

  </div>
</template>
<script>

import ImageUploader from '@/components/ImageUploader.vue';
import cateList from './components/cate-list.vue'
import {Message} from 'element-ui';
import bus from '@/js/common/bus.js';

export default {
  data() {
    return {
      loadDisabled: false,
      dialogVisible: false,
      requestData: {
        category_id: '',
        template_name: '',
        count: 50,
        page: 0,
      },
      handleType:'add',
      rules: {
        template_name: [
          {required: true, message: '请设置模板名称', trigger: 'change'},
          {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}
        ],
        cover_img_url: [
          {required: true, message: '请添加封面', trigger: 'blur'},
        ],
        page_id: [
          {required: true, message: '请输入页面Id', trigger: 'blur'},
        ],
      },
      currentPage: 1,
      template_list: [],
      totalNumber: 0,
      activeName: '',
      category_name: '0',
      dialogClassVisible: false,
      categories: [{
        id: '0',
        category_name: '全部'
      }]
    };
  },
  components: {
    ImageUploader,
    cateList
  },
  computed: {
    isHasPermission() {
      // 是否有删除和修改的权限
      const authStr = decodeURIComponent(lib.cookie.get('authority') || '');
      return authStr.includes('4')

    }
  },
  created() {
     this.getCategory()
     bus.$on('refreshTable', this.getTemplateList)
  },
  methods: {
    addNew(){
      this.$router.push({
        path: '/tms',
      });
    },
    //模板列表
    getTemplateList(page) {
      if(page !== undefined) {
        this.requestData.page = page
      } else {
        this.requestData.page++
      }
      if(this.requestData.page === 1) {
        this.loadDisabled = false
      }
      return lib.tmsapi.get({
        api: 'api/test/template/list',
        data: {
          ...this.requestData,
          page: this.requestData.page - 1,
        },
        success: (res) => {

          if (res && res.data) {
            if(this.requestData.page === 1) {
              this.template_list = res.data;
            } else {
              this.template_list.push(...res.data);
            }
            this.totalNumber = res.total;
            this.template_list.forEach((val, index) => {
              if(!val.qrcode_url){
                val.qrcode_url = 'https://yytools.mockuai.com/h5.html/browse?page_id='+val.page_id;
              }
              val.create_time = val.create_at ? new Date(+val.create_at).toLocaleDateString() : ''
            });
          }
          if(this.template_list.length >= this.totalNumber) {
            this.loadDisabled = true
          }
        },
      })
    },
    //点击搜索
    clickSearch() {
      this.requestData.category_id = '';
      this.getTemplateList(1);
    },


    addCategory () {
      lib.tmsapi.post({
        api: 'api/test/template_category/add',
        data: {
          category_name: this.category_name
        },
        success: (res) => {
          this.$message.success('添加分类成功！')
          // 关闭弹框
          this.dialogClassVisible = false;
          // 添加成功，刷新列表
          this.getCategory()
          // this.getTemplateList(1);

        },
        error:()=>{
          this.$message.error('添加分类失败！')
        }
      })
    },

    getCategory () {

      lib.tmsapi.get({
        api: 'api/test/template_category/list',
        success: (res) => {
          this.categories = res.data
          this.categories.forEach(item => {
            item.id = item.id + ''
            item.color = ['#F2920C', '#5997E8', '#2953DB', '#DC715A'][Math.floor((Math.random() * 10) % 4)]
          })
          this.getTemplateList(1);
        }
      })
    },

    tabChange () {
      this.requestData.category_id = this.activeName === '0' ? '' : this.activeName
      this.template_list = []
      this.getTemplateList(1);
    }

  },
};
</script>
<style lang="scss" scoped>
.template {
  padding: 16px;
  background: #F3F5F7;
}
.content-top {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 10px 15px;
  border-radius: 8px 8px 0px 0px;
  border-bottom: 1px solid #F3F5F7;
  background: #fff;
  .template-search {
    margin-left: 20px;
    .template-search-button {
      background: #3E89FF;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      color: #fff;
    }
  }
}

.tabs {
  display: flex;
  padding: 0 36px 0 20px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  background: #fff;
  border-radius: 0px 0px 8px 8px;
  /deep/ .el-tabs {
    width: 80%;
  }
  /deep/ .el-tabs__header {
    margin: 0;
  }
  /deep/ .el-tabs__nav-wrap::after {
    height: 0px;
  }
}

.template-item {
  padding-bottom: 15px;
  overflow-y: scroll;
  height: calc(100vh - 240px);
}

</style>

